import React, { useLayoutEffect, useRef } from "react";
import { bookingPhoneDigits, formatPhoneNumber } from "./phoneNumber";

function caretForNumber(formatted, count) {
  if (!count) return 0;
  let seen = 0;
  for (let index = 0; index < formatted.length; index += 1) {
    if (/\d/.test(formatted[index])) seen += 1;
    if (seen === count) return index + 1;
  }
  return formatted.length;
}

export default function BookingPhoneInput({ value, onChange, onBlur, error, disabled, name = "phone" }) {
  const inputRef = useRef(null);
  const caretRef = useRef(null);
  const formatted = formatPhoneNumber(value);

  useLayoutEffect(() => {
    if (caretRef.current !== null && document.activeElement === inputRef.current) {
      const position = caretForNumber(formatted, caretRef.current);
      inputRef.current.setSelectionRange(position, position);
    }
    caretRef.current = null;
  });

  const updateNumber = (text, position) => {
    caretRef.current = bookingPhoneDigits(text.slice(0, position)).length;
    onChange(bookingPhoneDigits(text));
  };

  const handleKeyDown = (event) => {
    const { selectionStart: start, selectionEnd: end } = event.currentTarget;
    if (start !== end) return;
    let index = event.key === "Backspace" ? start - 1 : event.key === "Delete" ? start : -1;
    if (index < 0 || index >= formatted.length || /\d/.test(formatted[index])) return;
    const direction = event.key === "Backspace" ? -1 : 1;
    while (index >= 0 && index < formatted.length && !/\d/.test(formatted[index])) index += direction;
    if (index < 0 || index >= formatted.length) return;
    event.preventDefault();
    updateNumber(formatted.slice(0, index) + formatted.slice(index + 1), direction < 0 ? index : start);
  };

  return (
    <div className="field-wrap">
      <label htmlFor="booking-phone">Return phone number <span className="schedule-required">*</span></label>
      <input ref={inputRef} id="booking-phone" name={name} type="tel" inputMode="tel" autoComplete="tel"
        placeholder="XXX-XXX-XXXX" value={formatted} disabled={disabled} maxLength={12}
        aria-required="true" aria-invalid={!!error} aria-describedby={error ? "booking-phone-error" : undefined}
        onChange={(event) => updateNumber(event.target.value, event.target.selectionStart)} onBlur={onBlur} onKeyDown={handleKeyDown} />
      {error && <div id="booking-phone-error" className="error-text" role="alert">{error}</div>}
    </div>
  );
}
